<app-mb-modal
  [isVisible]="isVisible"
  [title]="'Incoming Complaint'"
  [width]="'95%'"
  [desktopWidth]="'70%'"
  [okText]="'Edit Case'"
  [icon]="ASSET_CONSTANTS.I_stars"
  [okDisabled]="!isFormValid()"
  (isVisibleChange)="isVisibleChange.emit($event)"
  (CancelActionHandler)="handleCancel()"
  (OkActionHandler)="handleSubmit()"
>
  <form
    (ngSubmit)="onSubmit()"
    [formGroup]="editCaseForm"
    class="flex flex-row h-full"
  >
    <div class="w-3/5 overflow-y-scroll mx-6 mt-6 flex flex-col space-y-4">
        <app-mb-banner
        [title]="'Complaint'"
        [type]="'info'"
        [icon]="ASSET_CONSTANTS.I_question"
      >
        <p class="text-mbaza-gray">
          Reported on:
          <span class="font-bold text-black">
            {{
              case?.createdAt ? (case?.createdAt | date : "MMM d, y") : "N/A"
            }}
          </span>
        </p>
      </app-mb-banner>
      <div class="grid grid-cols-2 gap-4">
        <app-mb-input
          [placeholder]="'Enter National ID'"
          [prefixLabel]="'NID:'"
          [ngModel]="case?.contact?.documentNumber || ''"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="true"
        />

        <app-mb-input
          type="phone"
          [prefixLabel]="'Phone:'"
          [ngModel]="case?.contact?.phone || ''"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="true"
        />

        <app-mb-input
          [placeholder]="'Enter Name'"
          [prefixLabel]="'First Name:'"
          [ngModel]="case?.contact?.firstName || ''"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="true"
        />

        <app-mb-input
          [placeholder]="'Enter name (optional)'"
          [prefixLabel]="'Middle Name:'"
          [ngModel]="''"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="true"
        />

        <app-mb-input
          [placeholder]="'Enter Name'"
          [prefixLabel]="'Last Name:'"
          [ngModel]="case?.contact?.lastName || ''"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="true"
        />

        <app-mb-input
          [placeholder]="'Enter Email'"
          [prefixLabel]="'Email:'"
          [ngModel]="case?.contact?.email || ''"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="true"
        />
      </div>
      <div class="grid grid-cols-1 gap-1">
        <span class="text-base font-black">ISSUE LOCATIONS</span>
        <div class="grid grid-cols-2 gap-4">
          <app-mb-input
            [prefixLabel]="'District:'"
            placeholder="Select District"
            [ngModel]="case?.location?.districtName || ''"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="true"
          />

          <app-mb-input
            [prefixLabel]="'Sector:'"
            placeholder="Select Sector"
            [ngModel]="case?.location?.sectorName || ''"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="true"
          />

          <app-mb-input
            [prefixLabel]="'Cell:'"
            placeholder="Cell"
            [ngModel]="case?.location?.cellName || ''"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="true"
          />

          <app-mb-input
            [prefixLabel]="'Village:'"
            placeholder="Village"
            [ngModel]="case?.location?.villageName || ''"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="true"
          />
        </div>
      </div>
      <div class="grid grid-cols-1 gap-1">
        <span class="text-base font-black">ISSUE DETAILS</span>
        <app-mb-input
          [placeholder]="'Complaint Title'"
          [prefixLabel]="'Title:'"
          [ngModel]="case?.title || ''"
          [ngModelOptions]="{ standalone: true }"
          [disabled]="true"
        />

        <div class="my-4">
          <span class="font-black mb-4">Complaint:</span>
          <app-mb-text-area
            [placeholder]="'Type your complaint'"
            [ngModel]="case?.description || ''"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Type your complaint"
            [disabled]="true"
          />
        </div>
      </div>
    </div>

    <div
      class="w-2/5 min-h-full bg-mbaza-primary-light p-6 flex flex-col gap-4 overflow-x-auto"
    >
      <app-mb-banner
        title="GOOD GOVERNANCE'S SECTION"
        [icon]="ASSET_CONSTANTS.I_headset"
      />

      <app-mb-select
        [prefixLabel]="'Case Type'"
        placeholder="Select type"
        [options]="caseTypeOptions$"
        formControlName="caseType"
      />

      <app-mb-select
        [placeholder]="'Select severity'"
        [prefixLabel]="'Severity'"
        formControlName="severity"
        [options]="[
          { value: 'LOW', label: 'Low' },
          { value: 'MEDIUM', label: 'Medium' },
          { value: 'HIGH', label: 'High' }
        ]"
      />

      <app-mb-select
        [options]="trackingLevelOptions"
        [placeholder]="'Select recording level'"
        [prefixLabel]="'Recording Lvl:'"
        formControlName="trackingLevel"
      />

      <app-mb-input
        [placeholder]="'Enter estimated days'"
        [prefixLabel]="'Est days:'"
        formControlName="estimatedDays"
        type="number"
      />

      <app-mb-select
        [options]="organizationOptions"
        [placeholder]="'Select primary organization'"
        [prefixLabel]="'Primary Org:'"
        formControlName="primaryOrganizationId"
      />

      <span class="text-base font-black mt-3"
        >Inform relevant institutions</span
      >

      <div class="institution-selector">
        <div
          class="flex flex-row gap-2 items-center border-1 border-mbaza-gray-dark rounded-sm px-4 py-2"
        >
          <span class="text-base font-bold">Search:</span>
          <nz-select
            nzShowSearch
            nzAllowClear
            nzBorderless="true"
            nzPlaceHolder="Search Institution"
            formControlName="institutions"
            [nzMode]="'multiple'"
            class="w-full"
            (ngModelChange)="onInstitutionChange($event)"
          >
            @for (institution of availableOrganizations; track institution.id) {
            <nz-option
              [nzLabel]="institution.name"
              [nzValue]="institution.id"
            ></nz-option>
            }
          </nz-select>
          <img [src]="ASSET_CONSTANTS.I_search" alt="Search" class="h-5 w-5" />
        </div>

        <!-- Selected institutions display below -->
        @if (selectedInstitutions && selectedInstitutions.length > 0) {
        <div class="selected-institutions mt-4">
          <div class="flex flex-col gap-2">
            @for (institutionId of selectedInstitutions; track institutionId;
            let i = $index) {
            <div
              class="flex items-center gap-2 justify-between w-full px-4 py-2 bg-gray-50 rounded"
            >
              <div class="flex flex-row gap-2 items-center w-full">
                <span class="pr-2 font-semibold">{{ i + 1 }}</span>
                <div class="h-6 w-6 bg-mbaza-gray-light rounded"></div>
                <span>{{ getInstitutionName(institutionId) }}</span>
              </div>
              <button
                type="button"
                (click)="removeInstitution(institutionId)"
                class="text-red-600 hover:text-red-800 ml-1"
              >
                <img
                  [src]="ASSET_CONSTANTS.I_cancel"
                  alt="Remove"
                  class="h-4 w-4"
                />
              </button>
            </div>
            }
          </div>
        </div>
        }
      </div>
    </div>
  </form>
</app-mb-modal>
